import { Dispatch, useMemo } from 'react';

import { useGetUserSettingsOnDemand } from '@api';

import { EUserAction, IUserActions, TUserActions } from './model';

export const useActions = (dispatch: Dispatch<TUserActions>): IUserActions => {
  const { request } = useGetUserSettingsOnDemand();

  return useMemo(
    () => ({
      loadUser: async () => {
        const result = await request();
        if (result) {
          dispatch({ action: EUserAction.SET_USER, payload: result });
        }
      },
      setUserEmail: (email: string) => {
        dispatch({ action: EUserAction.SET_USER_EMAIL, payload: { email } });
      },
    }),
    [dispatch, request],
  );
};
